import { Dispatch } from 'redux'
import { UPDATE_GROUPED_FILTERS } from './constants'

export const updateGroupedFilters = (
  dispatch: Dispatch,
  payload: GroupedProviderFilter
): void => {
  dispatch({
    type: UPDATE_GROUPED_FILTERS,
    payload,
  })
}
